import {Stack, Typography} from '@mui/material'
import React from 'react'
import {mdiCheckboxMarked, mdiCloseBox, mdiHistory, mdiTimerSand} from "@mdi/js";
import Icon from "@mdi/react";
import {DemandeBean, EtatBean} from "../ea/ui/suivieDemande/components/demandeConstants";

export enum DEMAND_ICON {
    HISTORY = 'history',
    CHECKBOX = 'checkbox',
    TIMER = 'timer',
    CLOSE_BOX = 'close'
}

export default class demandeUtils {
    static getDemandesEnAttente = (demandes: DemandeBean[]): DemandeBean[] =>
        (demandes || []).filter(demande => demande.documentsEnAttente && demande.documentsEnAttente.length > 0)

    static getDemandeLaPlusAncienneEnAttente = (demandes: DemandeBean[]): DemandeBean | undefined => {
        const demandesEnAttente = demandeUtils.getDemandesEnAttente(demandes)
        return demandesEnAttente && demandesEnAttente.length > 0 ? demandesEnAttente.at(-1) : undefined
    }

    static demandStatus = (etat: EtatBean, options: {
        variant?: string,
        fontWeight?: number,
        withoutPadding?: boolean,
        showDash?: boolean
    }, dashboard: boolean = false) => {
        const getDemandeIcon = () => {
            switch (etat.icon) {
                case DEMAND_ICON.HISTORY:
                    return mdiHistory
                case DEMAND_ICON.CHECKBOX:
                    return mdiCheckboxMarked
                case DEMAND_ICON.TIMER:
                    return mdiTimerSand
                case DEMAND_ICON.CLOSE_BOX:
                    return mdiCloseBox
                default:
                    return mdiHistory
            }
        }

        return (
            <Stack direction="row" spacing="8px" alignItems="center">
                {!dashboard && <Icon path={getDemandeIcon()} size="24px" color={etat.couleur}/>}
                {/*// @ts-ignore*/}
                <Typography noWrap variant={options?.variant ? options?.variant : 'subtitle1'}
                            fontWeight={options?.fontWeight ? options?.fontWeight : 500}
                            sx={options?.withoutPadding ? {color: etat.couleur} : {
                                color: etat.couleur,
                                marginLeft: '4px'
                            }}>
                    {etat.libelleEtat}
                </Typography>
            </Stack>
        )
    }
}
